import { Globe, Check } from "lucide-react";
import { LANGS, getLang, applyLang } from "@/i18n";
import api from "@/lib/api";

// Impostazioni → Lingua: vale per l'interfaccia e per le risposte dell'assistente.
export const LanguageSetting = () => {
  const current = getLang();
  const pick = async (code) => {
    if (code === current) return;
    await api.patch("/auth/preferences", { lang: code }).catch(() => {});
    applyLang(code);
  };
  return (
    <div className="rounded-xl border border-border bg-card p-5 sm:p-6 space-y-4" data-testid="language-setting">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center"><Globe className="w-5 h-5" /></div>
        <div>
          <h3 className="font-heading font-semibold">Lingua</h3>
          <p className="text-sm text-muted-foreground">Lingua dell'app e delle risposte dell'assistente.</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" translate="no" data-no-translate>
        {LANGS.map((l) => (
          <button key={l.code} type="button" onClick={() => pick(l.code)} data-testid={`language-setting-${l.code}`}
            className={`min-h-[48px] rounded-lg border px-3 text-base font-medium flex items-center justify-between transition-colors ${l.code === current ? "border-primary bg-primary/5 text-primary" : "border-border hover:bg-secondary"}`}>
            {l.label} {l.code === current && <Check className="w-4 h-4" />}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSetting;
